const { styled, Typography } = require('@mui/material')

export const CounterPartyTitleStyle = styled(Typography)({
  padding: '8px',
  color: '#A4A4FF',
  textAlign: 'center',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Nunito',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal'
})
